<template>
  <v-card width="90%" style="margin: 15px auto;">
    <ChatDialog
      v-if="chatDialogShow"
      :title="chatDialogTitle"
      :cardId="chatDialogCardId"
      @close="chatDialogShow = false"
    />
    <v-toolbar color="primary" dark>
      <v-toolbar-title>Тех. карты в очереди на рассмотрение</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="px-0 pb-0">
      <CardsTable
        url="/manufacture/card/index-agree"
        :key="cardsTableUK"
        >
        <template v-slot:status="{card}">
          <CardStatus :value="getCardStatus(card.status)"/>
        </template>
        <template v-slot:name="{card}">
          <router-link :to="cardViewUrl(card)">{{card.name}}</router-link>
        </template>
        <template v-slot:action="{ card }">
          <v-btn
            v-if="card.status == 16"
            icon
            color="primary"
            @click="showChatDialog(card)"
            >
            <v-icon>mdi-chat</v-icon>
          </v-btn>
        </template>
      </CardsTable>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import CardsTable from './components/CardsTable.vue'
import CardStatus from './components/CardStatus.vue'
import { cardStatuses } from '../../vars/index.js'
import ChatDialog from '../card-chat/ChatDialog.vue'

export default {
  components: {
    CardsTable,
    CardStatus,
    ChatDialog,
  },
  data: () => ({
    perPage: 5,
    cardsTableUK: 0,
    cardStatuses,
    chatDialogShow: false,
    chatDialogTitle: '',
    chatDialogCardId: 0,
  }),
  computed: {
    ...mapState('user', {
      userId: state => state.profile.userId,
    }),
  },
  methods: {
    showChatDialog(card) {
      this.chatDialogTitle = card.name
      this.chatDialogCardId = card.id
      this.chatDialogShow = true
    },
    cardViewUrl(card) {
      if (card.status == 8 || card.status == 16) {
        if (card.createdBy == this.userId) {
          return '/manufacture/card-comment/correct?id=' + card.id
        }
      } else {
        if (card.agreederId == this.userId) {
          return '/manufacture/card-comment/agree?id=' + card.id
        }
      }
      return '/manufacture/card-comment/view?id=' + card.id
    },
    getCardStatus(status) {
      let s = this.cardStatuses.find(cs => cs.id === Number(status))
      return s || { icon: 'mdi-help', text: 'Неизвестно', color: 'default' }
    },
  },
}
</script>
